<template>
  <div class="row">
    <div class="col-lg-8 m-auto">
      <o-card :title="$t('core.login')">
        <form @submit.prevent="login" class="pt-3" @keydown="form.onKeydown($event)">
          <!-- Email -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('core.email') }}</label>
            <div class="col-md-7">
              <input v-model="form.email" type="email" name="email" class="form-control"
                     :class="{ 'is-invalid': form.errors.has('email') }">
              <has-error :form="form" field="email"></has-error>
            </div>
          </div>

          <!-- Password -->
          <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('core.password') }}</label>
            <div class="col-md-7">
              <input v-model="form.password" type="password" name="password" class="form-control"
                     :class="{ 'is-invalid': form.errors.has('password') }">
              <has-error :form="form" field="password"></has-error>
            </div>
          </div>

          <!-- Remember Me -->
          <div class="form-group row">
            <div class="col-md-3"></div>
            <div class="col-md-7">
              <router-link :to="{ name: 'password.request' }" class="float-right small">
                {{ $t('core.forgot_password') }}
              </router-link>

              <b-form-checkbox v-model="remember" class="max-width-65">{{ $t('core.remember_me') }}</b-form-checkbox>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-7 offset-md-3 d-flex">
              <!-- Submit Button -->
              <o-button :loading="form.busy">
                {{ $t('core.login') }}
              </o-button>

              <!-- GitHub Login Button -->
              <a v-if="githubAuth" href="/oauth/github" class="btn btn-dark ml-auto">
                {{ $t('core.login_with') }}
                <fa :icon="['fab', 'github']"/>
              </a>

              <router-link :to="{ name: 'register' }" class="small ml-auto my-auto">
                {{ $t('core.register') }}?
              </router-link>
            </div>
          </div>
        </form>
      </o-card>
    </div>
  </div>
</template>

<style>
  .max-width-65 {
    max-width: 65%;
  }
</style>

<script>
  import Form from 'vform'
  import {setLocale} from '~/plugins/i18n'

  export default {
    data: () => ({
      form: new Form({
        email: '',
        password: ''
      }),
      remember: false
    }),

    methods: {
      async login() {
        // Submit the form.
        const {data} = await this.form.post('/api/login')

        // Save the token.
        this.$store.dispatch('auth/saveToken', {
          token: data.token,
          remember: this.remember
        })

        // Fetch the user.
        await this.$store.dispatch('auth/fetchUser')

        let lang = this.$store.state['auth']['user']['language']
        if (lang !== null && this.$i18n.locale !== lang) {
          setLocale(lang)
          this.$store.dispatch('lang/setLocale', { 'locale': lang })
        }

        // Redirect to previous page or home in case nothing was specified
        if (this.$route.query && this.$route.query.from) {
          this.$router.push(this.$route.query.from)
        } else {
          this.$router.push({name: 'home'})
        }
      }
    },

    computed: {
      githubAuth: () => window.config.githubAuth
    }
  }
</script>
